export default {"src":"/_next/static/media/blog-mailbox.f2591ec8.svg","height":302,"width":398};